export const setPunchOutData = (punchOut = {}) => ({
  type: 'UPDATE_PUNCH_OUT',
  punchOut,
});

export const updatePunchOutData = (punchoutData = {}) => async (dispatch) => {
  try {
    dispatch(setPunchOutData(punchoutData));
  } catch (error) {
    throw error;
  }
};
